import React from 'react';

import { Form, Field } from 'react-final-form';
import { CheckboxField, SelectField, TextField, CheckboxesField, LocationsField } from '/components/forms/fields';

import { ValidationService } from '/services';

const EstateSearchForm = () => {
    const initialValues = {
        locations: [],
        subCategories: [],
    };

    const validate = (values) => {
        const rules = {
            purpose: 'required',
            firstName: 'required',
            lastName: 'required',
            email: 'required|email',
            mobile: 'required',
            privacy: 'required',
            subCategories: 'required',
        };

        const names = {
            purpose: 'transactie',
            firstName: 'voornaam',
            lastName: 'achternaam',
            email: 'e-mailadres',
            mobile: 'telefoonnummer',
            subCategories: 'type',
        };

        return ValidationService.validate(values, rules, names);
    };

    const submit = async (values) => {
        const body = new FormData();
        body.append(window.csrfTokenName, window.csrfTokenValue);
        body.append('firstName', values.firstName);
        body.append('lastName', values.lastName);
        body.append('email', values.email);
        body.append('mobile', values.mobile);
        body.append('purpose', values.purpose && values.purpose.value);
        body.append('minPrice', values.minPrice);
        body.append('maxPrice', values.maxPrice);
        body.append('locations', values.locations.map(xxx => xxx.postalCode).join(','));
        body.append('bedrooms', values.minBedrooms);
        body.append('subCategories', values.subCategories.join(','));

        try {
            const response = await fetch('/index.php?p=actions/vitsync/estate-form/search', {
                method: 'post',
                body,
            });

            const bodyFromResponse = await response.json();

            if (bodyFromResponse.success) {
                window.location = window.successRedirect;
            } else {
                window.location = window.failureRedirect;
            }
        } catch {
            window.location = window.failureRedirect;
        }
    };

    const render = ({ handleSubmit }) => (
        <div className="estate-search-form-wrapper">
            <div className="container is-horizontal is-vertical">
                <form className="estate-search-form" onSubmit={handleSubmit}>
                    <div className="block is-large">
                        <h2 className="headline-2 is-centered">Uw wensen</h2>
                    </div>
                    <div className="block is-large">
                        <div className="estate-search-form__row-one">
                            <Field
                                name="purpose"
                                component={SelectField}
                                label="Transactie"
                                options={window.purposeOptions}
                                required
                            />
                            <Field
                                name="minPrice"
                                component={TextField}
                                label="Minimum prijs"
                                min="0"
                                type="number"
                            />
                            <Field
                                name="maxPrice"
                                component={TextField}
                                label="Maximum prijs"
                                type="number"
                                min="1"
                            />
                            <Field
                                name="locations"
                                component={LocationsField}
                                label="Gemeentes"
                            />
                            <Field
                                name="minBedrooms"
                                component={TextField}
                                label="Minimum aantal slaapkamers"
                                type="number"
                                min="0"
                            />
                            <Field
                                name="subCategories"
                                component={CheckboxesField}
                                label="Type"
                                options={window.categoryOptions}
                                type="checkbox"
                            />
                        </div>
                    </div>
                    <div className="block is-large with-giant-margin">
                        <h2 className="headline-2 is-centered">Uw contactgegevens</h2>
                    </div>
                    <div className="block is-large">
                        <div className="estate-search-form__row-two">
                            <Field
                                name="firstName"
                                component={TextField}
                                label="Voornaam"
                                type="text"
                                required
                            />
                            <Field
                                name="lastName"
                                component={TextField}
                                label="Naam"
                                type="text"
                                required
                            />
                            <Field
                                name="email"
                                component={TextField}
                                label="E-mailadres"
                                type="email"
                                required
                            />
                            <Field
                                name="mobile"
                                component={TextField}
                                label="Telefoonnummer"
                                type="tel"
                                required
                            />
                            <Field
                                name="privacy"
                                component={CheckboxField}
                                label={window.privacyMessage}
                                type="checkbox"
                                required
                            />
                        </div>
                    </div>
                    <div className="block is-large with-giant-margin">
                        <div className="action-row">
                            <button className="button is-orange font-supplementary--bold" type="submit">
                                Hou me op de hoogte
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );

    return (
        <Form
            initialValues={initialValues}
            validate={validate}
            onSubmit={submit}
            render={render}
        />
    );
};

export { EstateSearchForm };
